import { render, staticRenderFns } from "./zoomVideo.vue?vue&type=template&id=107fb809&"
import script from "./zoomVideo.vue?vue&type=script&lang=js&"
export * from "./zoomVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports